import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgChevronRightFilled = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m10.247 6.735 4.637 4.75a.734.734 0 0 1 0 1.031l-4.637 4.75a.8.8 0 0 1-1.1.028.73.73 0 0 1-.03-1.06l4.16-4.235-4.16-4.234a.73.73 0 0 1 .03-1.06.8.8 0 0 1 1.1.03"
    }));
export default SvgChevronRightFilled;
